export default "__VITE_ASSET__ee645eb0__"